import { Component } from "preact";

const eventTimeCheck = (WrappedComponent) => {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                eventTimeReached: false,
            };
        }

        checkEventTime() {
            this.setState({ eventTimeReached: true });
        };

        componentDidMount() {
            const { event, config } = this.props;
            const isSpeechScoreEnabled = config.enableSpeechScore;
            const isLockedFnc = config.isLocked;

            if (isSpeechScoreEnabled && !isLockedFnc() && event?.isScoreTrackable) {
                const timeUntilEvent = new Date(event.dateUtc).getTime() - Date.now();

                if (timeUntilEvent > 0) {
                    this.timeoutId = setTimeout(this.checkEventTime, timeUntilEvent);
                } else {
                    this.setState({ eventTimeReached: true });
                }
            }
        }

        componentWillUnmount() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
        }

        render() {
            return (
                <WrappedComponent
                    eventTimeReached={this.state.eventTimeReached}
                    {...this.props}
                />
            );
        }
    };
};

export default eventTimeCheck;
